import Retry from 'Utilities/Retry'
import safeDecodeURIComponent from 'Utilities/UrlUtilities/safeDecode'

import { NOT_FOUND_COOKIE } from 'Constants/Cookies'

const initialState = {
  cookie: NOT_FOUND_COOKIE,
  guid: null,
}

export const SetSelectedCustomerProjectFromCookie = async (
  customerProjects,
  userGuid,
  url,
  updateCustomerProjects,
  FindMatchingProjects,
) => {
  if (document.cookie) {
    const cookieArr = document.cookie.split(';')
    const encodedCookie = cookieArr.filter((cookie) => cookie.includes('FitmentCookie'))[0]

    // if (encodedCookie) {
    //     try {
    //         JSON.parse(encodedCookie)
    //     }
    //     catch (e) {
    //         document.cookie = 'FitmentCookie=' + encodeURIComponent(JSON.stringify(encodedCookie)) + ';path=/'
    //     }
    // }

    const parsedCookie = safeDecodeURIComponent(encodedCookie)

    try {
      if (parsedCookie !== encodedCookie) {
        document.cookie = 'FitmentCookie=' + parsedCookie + ';path=/'
      }
    } catch (err) {
      console.error('There was an error trying to decode the cookie.', err)
    }

    if (parsedCookie) {
      const matchingProjects = FindMatchingProjects(parsedCookie, customerProjects)
      if (matchingProjects.length === 0 && (parsedCookie?.VehicleBaseId != null || parsedCookie?.RaceTypeId != null)) {
        //save to customerProjects with the vehicleBaseID and racetype (only one should ever exist)
        const customerProjectModule = await Retry(() => import('Contexts/VehicleContext/CoreVehicleRequests'))
        const response = await customerProjectModule.AddUserVehicle(
          userGuid,
          url,
          null,
          null,
          null,
          parsedCookie?.RaceTypeId,
          parsedCookie?.VehicleBaseId,
        )
        if (response?.length) {
          updateCustomerProjects(response?.addNewProjectToGarage?.projects)
        }

        return {
          cookie: parsedCookie,
          guid: response?.addNewProjectToGarage?.webUser?.userGuid,
        }
      }

      return {
        cookie: parsedCookie,
        guid: null,
      }
    } else {
      return initialState
    }
  } else {
    console.error('Document not found')
    return initialState
  }
}
